import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "flowbite-react";
import FormInput from "../forms/FormInput";
import { useAuth } from "../../contexts/AuthContext";
import { completeRegistration } from "../../api/auth";
import { handleError } from "../../services/error";

const LoginForm = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [formData, setFormData] = useState({
    password: '',
    key: queryParams.get('key'),
  });

  const [isProcessing, setIsProcessing] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setErrors({});

    try {
      const response = await completeRegistration(formData);
      const { user, token } = response;

      if (!user || !token) {
        toast.error('An unknown error occurred. Please try again.');
        setIsProcessing(false);
        return;
      }

      setAuthUser(user, token);
      navigate('/');
    } catch (err) {
      setIsProcessing(false);
      console.error(err);

      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        handleError(err);
      }
    }
  };

  return (
    <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
      <FormInput
        input={{
          type: 'password',
          name: 'password',
          id: 'password',
          label: 'Password',
          placeholder: '',
          required: true,
          value: formData.password,
        }}
        onChange={handleChange}
        error={errors?.password}
      />
      <Button
        type="submit"
        className="w-full"
        isProcessing={isProcessing}
        disabled={isProcessing}
      >
        Sign up
      </Button>
    </form>
  );
};

export default LoginForm;
